"use client";

import { cn } from "@/utils";

type ChartUnitToggleProps = {
  unit: "hex" | "usd";
  onChange: (unit: "hex" | "usd") => void;
};

export function ChartUnitToggle({ unit, onChange }: ChartUnitToggleProps) {
  return (
    <div
      className="flex rounded-lg border border-white/10 bg-surface-400/40 p-0.5 text-2xs"
      role="group"
      aria-label="Value unit"
    >
      <button
        type="button"
        onClick={() => onChange("hex")}
        className={cn(
          "rounded-md px-2.5 py-1.5 font-medium transition-colors",
          unit === "hex" ? "bg-surface-300 text-white" : "text-muted hover:text-white",
        )}
      >
        HEX
      </button>
      <button
        type="button"
        onClick={() => onChange("usd")}
        className={cn(
          "rounded-md px-2.5 py-1.5 font-medium transition-colors",
          unit === "usd" ? "bg-surface-300 text-white" : "text-muted hover:text-white",
        )}
      >
        USD
      </button>
    </div>
  );
}

export default ChartUnitToggle;
